function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { useDispatch } from 'react-redux';
import { useErrorHandling } from '../../hooks/useErrorHandling';
import { useCallback, useEffect, useState } from 'react';
import { setIsUnderTechnicalReview } from '../../store/features/reviewSlice';
import serviceMethods from '../service_methods';
import { buildService } from '../service';
const api = buildService('/claims', {
  only: ['all', 'get', 'create', 'update', 'delete']
});
function get(id) {
  return fetch("/api/claims/".concat(id), request.get);
}
function update(claim) {
  claim.internal_invoice_detail_attributes = claim.internal_invoice_detail_attributes || claim.internal_invoice_detail;
  return fetch("/api/claims/".concat(claim.id), _objectSpread(_objectSpread({}, request.put), {}, {
    body: JSON.stringify({
      claim
    })
  }));
}
;
function create(claim) {
  return fetch('/api/claims/', _objectSpread(_objectSpread({}, request.post), {}, {
    body: JSON.stringify({
      claim
    })
  }));
}
function updateInvoiced(claim, invoiceDetails) {
  claim.internal_invoice_detail || (claim.internal_invoice_detail = {});
  claim.internal_invoice_detail.final_benefit_amount = invoiceDetails.final_benefit_amount;
  claim.internal_invoice_detail.invoice_amount = invoiceDetails.invoice_amount;
  return update(claim);
}
;
function uploadTechnicalDocument(claimId, fd) {
  return fetch("/api/claims/".concat(claimId, "/upload_technical_document"), _objectSpread(_objectSpread({}, request.post), {}, {
    headers: {
      'Accept': 'application/json, text/plain, */*'
    },
    body: fd
  }));
}
;
function deleteTechnicalDocument(claimId, document_id) {
  return fetch("/api/claims/".concat(claimId, "/delete_technical_document"), _objectSpread(_objectSpread({}, request.post), {}, {
    body: JSON.stringify({
      document_id
    })
  }));
}
;
function deleteClaim(id) {
  return fetch("/api/claims/".concat(id), _objectSpread({}, request.delete));
}
const claimService = {
  // Refactoring to set the isUnderReview state on claim fetch.
  // To replace get when the refactoring is done.
  useGetClaim(claimId) {
    let initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const [claim, setClaim] = useState(initialState);
    const dispatch = useDispatch();
    const fetchAndUpdateTechnicalReviewState = useErrorHandling(useCallback(async () => {
      if (claimId) {
        const fetchedClaim = await claimService.get(claimId);
        setClaim(fetchedClaim);
        dispatch(setIsUnderTechnicalReview(!!fetchedClaim.claim_group.active_change_set));
      }
    }, [claimId, dispatch]));
    useEffect(() => {
      fetchAndUpdateTechnicalReviewState(claimId);
    }, [fetchAndUpdateTechnicalReviewState, claimId]);
    return [claim, setClaim, fetchAndUpdateTechnicalReviewState];
  },
  useFetch(_ref) {
    let {
      claimId,
      setLoading,
      fetchImmediately = true
    } = _ref;
    const dispatch = useDispatch();
    const [claim, setClaim, fetchClaim] = serviceMethods.useFetch({
      callback: useCallback(async () => {
        if (!claimId) {
          return;
        }
        const fetchedClaim = await api.get(claimId);
        /**
         * We are constantly watching the technical review state in the redux state, so we
         * should set it for each claim.
         */
        dispatch(setIsUnderTechnicalReview(!!fetchedClaim.claim_group.active_change_set));
        return fetchedClaim;
      }, [claimId, dispatch]),
      setLoading,
      fetchImmediately,
      initialStateValue: null
    });
    return [claim, setClaim, fetchClaim];
  },
  useUpdate(_ref2) {
    let {
      claimId,
      setLoading,
      setClaim,
      onSuccess
    } = _ref2;
    const updateClaim = serviceMethods.useUpdate({
      callback: useCallback(async claim => {
        const updated = await api.update(claimId, {
          claim
        });
        setClaim && setClaim(_objectSpread({}, updated));
        return updated;
      }, [claimId, setClaim]),
      setLoading,
      onSuccess
    });
    return updateClaim;
  },
  get,
  update,
  updateInvoiced,
  uploadTechnicalDocument,
  deleteTechnicalDocument,
  deleteClaim,
  create
};
export default claimService;